<mf-page title="Editar cuenta">
  @if (bankAccountDto) {
  <mf-bank-account
    [bankAccountDto]="bankAccountDto"
    (verify)="verify()"
    (save)="save($event)" />
  }
</mf-page>
